var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar-nav-icon',[_c('v-btn',{attrs:{"to":_vm.backRoute,"exact":"","icon":""}},[_c('v-icon',[_vm._v("arrow_back")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }